import config from 'config'
import {
  getMediaGallery,
  configurableChildrenImages,
  attributeImages
} from './'
import uniqBy from 'lodash-es/uniqBy'
import Product from '@vue-storefront/core/modules/catalog/types/Product';

function getProductVideoItem (product: Product) {
  const rawVideoValue = typeof product.video === 'string' ? product.video.trim() : ''
  if (!rawVideoValue) return null

  const isAbsoluteUrl = /^https?:\/\//i.test(rawVideoValue)
  const normalizedVideoValue = rawVideoValue.replace(/^\/+/, '')
  const videoUrl = isAbsoluteUrl
    ? rawVideoValue
    : `/media/file_upload_attribute/download/${normalizedVideoValue}`

  const fallbackThumb = product.image && product.image !== 'no_selection'
    ? product.image
    : config.images.productPlaceholder

  return {
    src: videoUrl,
    loading: fallbackThumb,
    error: fallbackThumb,
    video: {
      url: videoUrl
    },
    isVideo: true
  }
}

export default function getProductGallery (product: Product) {
  const videoItem = getProductVideoItem(product)

  if (product.type_id === 'configurable' && product.hasOwnProperty('configurable_children')) {
    if (!config.products.gallery.mergeConfigurableChildren && product.is_configured) {
      const configuredProductGallery = attributeImages(product)
      if (videoItem) {
        configuredProductGallery.push(videoItem)
      }
      return configuredProductGallery
    }
  }

  const productGallery = uniqBy(configurableChildrenImages(product).concat(getMediaGallery(product)), 'src')
    .filter(f => f.src && f.src !== config.images.productPlaceholder)

  if (videoItem) {
    productGallery.push(videoItem)
  }

  return productGallery
}
